import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import BoostIcon from '@wix/da-ds/pkg/Icons/24x24/Boost';
import BoostFilledIcon from '@wix/da-ds/pkg/Icons/24x24/BoostFilled';
import BoostRootModal from './modals/BoostRootModal';
import { BiData } from '@wix/da-bi/pkg/events';
const BoostButton = ({ deviation, className })=>{
    var _deviation_extended;
    const { t } = useTranslation();
    const isBoosted = (_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.boosted;
    const [isShowingModal, setShowingModal] = useState(false);
    const showModal = ()=>setShowingModal(true);
    const closeModal = ()=>setShowingModal(false);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ActionBarItemWrapper, {
        className: className,
        tooltip: t(isBoosted ? 'actionbar.currentlyBoosted' : 'actionbar.boost')
    }, /*#__PURE__*/ React.createElement(IconButton, {
        disabled: isBoosted,
        size: "medium",
        icon: isBoosted ? BoostFilledIcon : BoostIcon,
        onClick: showModal,
        "aria-label": isBoosted ? t('actionbar.currentlyBoosted') : t('actionbar.boost'),
        biData: BiData({
            evid: 320,
            sectionname: 'action_bar',
            itemid: deviation.deviationId,
            typeid: deviation.typeId,
            badge_type: 'boost',
            badge_typeid: 176
        })
    })), isShowingModal && /*#__PURE__*/ React.createElement(BoostRootModal, {
        deviation: deviation,
        onRequestClose: closeModal
    }));
};
BoostButton.displayName = 'BoostButton';
export default BoostButton;

//# sourceMappingURL=BoostButton.js.map